/**
 * Voltra cart/PDP UX polish (2026-09-15)
 * - Cart/drawer: strip "Don't Include" / "Mount only" from bundle component labels under "+ DIY Dock"
 * - PDP: do NOT rewrite Sold out → custom copy; leave Amp Notify me for true OOS Include
 * Does NOT touch Include→UNLISTED remap (voltra-bundles-simple-upright.js).
 */
(function () {
  'use strict';
  if (window.__voltraCartUxPolish) return;
  window.__voltraCartUxPolish = true;

  function isDiyDockParentTitle(text) {
    return /\+\s*DIY Dock/i.test(String(text || ''));
  }
  function stripDontInclude(text) {
    var t = String(text || '');
    t = t.replace(/\s*\/\s*Don['\u2019]?t Include/gi, '');
    t = t.replace(/\s*\/\s*Dont Include/gi, '');
    t = t.replace(/\s*\/\s*Mount only/gi, '');
    t = t.replace(/\bDon['\u2019]?t Include\b/gi, '');
    t = t.replace(/\bDont Include\b/gi, '');
    t = t.replace(/\bMount only\b/gi, '');
    t = t.replace(/\s{2,}/g, ' ').replace(/\s+-\s*$/, '').trim();
    return t || 'Mount';
  }

  function polishCartBundleLabels(root) {
    var scope = root || document;
    scope.querySelectorAll('.cart-items__table-row').forEach(function (row) {
      var titleEl = row.querySelector('.cart-items__title');
      var parentTitle = titleEl ? titleEl.textContent : '';
      var hrefDiy = !!row.querySelector('a.cart-items__title[href*="diy-dock"]');
      if (!isDiyDockParentTitle(parentTitle) && !hrefDiy) return;
      row.querySelectorAll('.cart-items__bundle li').forEach(function (li) {
        if (li.dataset.voltraDontStripped === '1') return;
        var qtySpan = li.querySelector('span');
        var qtyHtml = qtySpan ? qtySpan.outerHTML : '';
        var raw = '';
        for (var i = 0; i < li.childNodes.length; i++) {
          if (li.childNodes[i].nodeType === 3) raw += li.childNodes[i].textContent;
        }
        if (!raw) raw = li.textContent || '';
        if (!/don['\u2019]?t include|dont include|mount only/i.test(raw)) return;
        var cleaned = stripDontInclude(raw);
        li.textContent = '';
        li.appendChild(document.createTextNode(cleaned));
        if (qtyHtml) li.insertAdjacentHTML('beforeend', qtyHtml);
        li.dataset.voltraDontStripped = '1';
      });
    });
  }

  function polishAll() {
    polishCartBundleLabels(document);
  }

  var _t = null;
  function schedule() {
    if (_t) clearTimeout(_t);
    _t = setTimeout(polishAll, 50);
  }

  document.addEventListener('change', schedule, true);
  document.addEventListener('product:selected', schedule, true);
  document.addEventListener('cart:update', schedule, true);
  document.addEventListener('cart-update', schedule, true);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
  setTimeout(schedule, 200);
  setTimeout(schedule, 800);
  try {
    var mo = new MutationObserver(schedule);
    mo.observe(document.documentElement, { childList: true, subtree: true });
  } catch (_) {}
})();
